export interface IPage {
  id: string;
  isEvaluable: boolean;
  isEvaluation: boolean;
  nPage: number;
  isLocked: boolean;
}

export class Page implements IPage {
  id: string;
  isEvaluable: boolean;
  isEvaluation: boolean;
  nPage: number;
  isLocked: boolean;

  constructor() {
    this.id = '';
    this.isEvaluable = false;
    this.isEvaluation = false;
    this.nPage = 0;
    this.isLocked = false;
  }

  fromJSON(json: any): Page {
    return Object.assign(new Page(), json);
  }
}

export interface IPaginationPage {
  id: string;
  nPage: number;
  visibility: {
    isActive: boolean;
    isDisplayed: boolean;
    isDisabled: boolean;
    isSaved: boolean;
  };
  lock: {
    isDisplayed: boolean;
  };
}

export class PaginationPage implements IPaginationPage {
  id: string;
  nPage: number;
  visibility: {
    isActive: boolean;
    isDisplayed: boolean;
    isDisabled: boolean;
    isSaved: boolean;
  };
  lock: {
    isDisplayed: boolean;
  };

  constructor() {
    this.id = '';
    this.nPage = 0;
    this.visibility = { isActive: false, isDisplayed: false, isDisabled: false, isSaved: false };
    this.lock = { isDisplayed: false };
  }

  fromJSON(json: any): Page {
    return Object.assign(new Page(), json);
  }
}

export interface IPaginationConfig {
  nCurrentPage: number;
  pages: IPaginationPage[];
  addClasses: string;
  addSelectedClasses: string;
  addDisabledClasses: string;
  addEyeClasses: string;
  addSavedExercise: string;
}

export class PaginationConfig implements IPaginationConfig {
  nCurrentPage: number;
  pages: IPaginationPage[];
  addClasses: string;
  addSelectedClasses: string;
  addDisabledClasses: string;
  addEyeClasses: string;
  addSavedExercise: string;

  constructor() {
    this.nCurrentPage = 1;
    this.pages = [];
    this.addClasses = 'bg-grey cursor-pointer ';
    this.addSelectedClasses = 'bg-recursos cursor-pointer';
    this.addDisabledClasses = 'bg-white text-grisMedio2 border-inactive';
    this.addEyeClasses = 'bg-white cursor-pointer';
  }

  fromJSON(json: any): PaginationConfig {
    const config = new PaginationConfig();
    Object.assign(config, json);
    config.pages = json.pages.map(page => new Page().fromJSON(page));
    return config;
  }
}
